import { $ } from '@situation/setdesign.util';

$(document).one('TicketCalendar.init', (e, TicketCalendar, $on) => {
    $on('fc-view-render', (view, element) => {
        const $bestAvailability = element.find('.tc-availability--best');
        let delay = 0;
        $bestAvailability.each(() => {
            const $this = $(this);
            delay = Math.round(Math.random() * 1500);
            setTimeout(() => {
                $this.addClass('animate');
            }, delay);
        });
    });

    $on(TicketCalendar.FILTER_DEFAULTS, (defaults) => {
        defaults.update({
            // set to the $tc-theme-name sass variable
            theme: 'mjmusical-theme',
            'disable-default-analytics': true,
            // set a different width to switch to desktop view
            /* 'breakpoint': 1025, */
            // use a parent container if components are separated
            /* 'vue-parent': $('.js-ticket-calendar-wrap').length ? '.js-ticket-calendar-wrap' : '.ticket-calendar', */
            // change the aspect ratio of calendar date cells
            /* 'fullcalendar': {
                aspectRatio: 1.1
            }, */
            // change the height of scroll wheel rows
            /* 'mobiscroll': {
                height: 35
            }, */
            // change properties of the tag highlighter
            /* 'tag-highlighter': {
                instructionText: '<p>Filter above to see best options!</p>'
            }, */
            // add a custom arrow svg icon with class called .tc-accordion__toggle-custom
            'accordion-month-header': { arrowSvgName: 'icon-arrow' },
        });
    });
});
